import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts'
import type { ProcurementQuotesChartPoint } from './types'

export function QuotesByDayChart({
  points,
  avgResponseHours,
}: {
  points: ProcurementQuotesChartPoint[]
  avgResponseHours: number | null
}) {
  const hasData = points.some((p) => p.quotes > 0)
  return (
    <div className="bg-white rounded-2xl border border-gray-200 p-4 h-full flex flex-col">
      <div className="flex items-center justify-between flex-wrap gap-2">
        <div className="text-sm text-gray-500">Мои квоты по дням</div>
        {avgResponseHours !== null && (
          <span className="text-xs text-gray-500">
            Ср. время ответа:{' '}
            <span className="font-semibold text-gray-900">{avgResponseHours}ч</span>
          </span>
        )}
      </div>

      <div className="flex-1 min-h-[220px] mt-2">
        {hasData ? (
          <ResponsiveContainer width="100%" height="100%" minHeight={120}>
            <BarChart data={points} margin={{ top: 8, right: 8, left: 0, bottom: 8 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#f3f4f6" />
              <XAxis
                dataKey="label"
                tick={{ fontSize: 11, fill: '#6b7280' }}
                axisLine={{ stroke: '#e5e7eb' }}
                tickLine={false}
              />
              <YAxis
                tick={{ fontSize: 11, fill: '#6b7280' }}
                axisLine={{ stroke: '#e5e7eb' }}
                tickLine={false}
                allowDecimals={false}
              />
              <Tooltip
                formatter={(v) => [`${Number(v)} квот`, 'Создано']}
                contentStyle={{
                  borderRadius: 8,
                  border: '1px solid #e5e7eb',
                  fontSize: 12,
                }}
              />
              <Bar dataKey="quotes" fill="#3b82f6" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        ) : (
          <div className="h-full flex items-center justify-center text-sm text-gray-400">
            Нет квот за период
          </div>
        )}
      </div>
    </div>
  )
}
